// extracted by mini-css-extract-plugin
export default {"animatedList":"AnimatedList_animatedList__5uXKw","inView":"AnimatedList_inView__B74wl","listItem":"AnimatedList_listItem__Gln11"};